module.exports = __webpack_public_path__ + "img/korektif.c6a1a627.svg";